import { render } from "./UpdateApp.vue?vue&type=template&id=402943e2"
import script from "./UpdateApp.vue?vue&type=script&lang=js"
export * from "./UpdateApp.vue?vue&type=script&lang=js"

import "./UpdateApp.vue?vue&type=style&index=0&id=402943e2&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__